import axios from "axios";

import { API_ENDPOINTS } from '../../apiConfig';

const API_BASE =  `${API_ENDPOINTS.common}/documents`;
 
export interface DocumentFilterDTO {
    tenantId: string;      // UUID represented as string
    entityType: string;
    entityId: string;      // UUID represented as string
    bucketName?: string;
  }

export interface UploadDocumentParams {
  tenantId: string;
  entityType: string;
  entityId: string;
  file: File;
  bucketName: string;
}

export interface DocumentUploadResponse {
  documentId: string;
  fileName: string;
  fileUrl: string;
  uploadedAt: string;
  contentType: string;
  entityType: string;
}

export const uploadDocument = async (
    tenantId: string,
    entityId: string,
    entityType: string,
    files: File[],
    bucketName: string
  ): Promise<DocumentUploadResponse[]> => {
    const formData = new FormData();
  
    formData.append("tenantId", tenantId);
    formData.append("entityId", entityId);
    formData.append("entityType", entityType);
    formData.append("bucketName", bucketName);
  
    files.forEach((file) => {
      formData.append("files", file); // must match @RequestParam("files")
    });
  
    const response = await axios.post<DocumentUploadResponse[]>(
      `${API_BASE}/upload/multiple`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  
    return response.data;
  };

  export const getEntityDocuments = async (formData :DocumentFilterDTO) => axios.post(`${API_BASE}/get-entity-docs`, formData);
  export const deleteDocument = async (id: string) => axios.delete(`${API_BASE}/${id}`);
  